<template>
  <b-breadcrumb>
    <b-breadcrumb-item
      v-for="(breadcrumb, idx) in breadcrumbsList"
      :key="idx"
      @click.prevent="routeTo(idx)"
      :text="idx === 0 ? $t(breadcrumb.text) : breadcrumb.text"
      :active="!breadcrumb.link"
      :href="breadcrumb.link">
    </b-breadcrumb-item>
  </b-breadcrumb>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Breadcrumbs',
    methods: {
      routeTo(index) {
        const link = this.breadcrumbsList[index].link;
        link && this.$router.push(link);
      }
    },
    computed: {
      ...mapState('location', ['pathName', 'breadcrumbsList'])
    }
  }
</script>

<style scoped lang="scss">
  .breadcrumb {
    background-color: transparent;
    padding: 0;
    margin: 0 0 0 15px;
  }

  .breadcrumb-item {
    a {
      color: #2891c3;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Breadcrumbs.vue